import * as React from "react";
import {CSSProperties} from "react";
import classNames = require("classnames");
import "../common/commonDetailsSummary.scss";

interface IProps {
	/**
	 * Info items to be displayed.
	 */
	items: DetailsSummaryItem[];
	/**
	 * "Total" row item.
	 */
	totalItem: DetailsSummaryItem;
	/**
	 * Last item.
	 */
	lastItem?: DetailsSummaryItem;
	/**
	 * Render tooltip parent element.
	 */
	renderTooltipParentElement?: () => JSX.Element;
	/**
	 * Custom styles for container.
	 */
	style?: CSSProperties;
	/**
	 * Custom class for container.
	 */
	customClass?: string;
	/**
	 * Extra width.
	 */
	extraWidth?: boolean;
}

export interface DetailsSummaryItem {
	/**
	 * Item label.
	 */
	label: string;
	/**
	 * Item value.
	 */
	value: string;
	/**
	 * Indicates if italic font style is used to render item.
	 */
	italic?: boolean;
}

export const CommonDetailsSummary: React.SFC<IProps> = (props) => {
	const containerClassFromProps = classNames({
		"c-common-summary_container": true,
		"extra-width": props.extraWidth,
		[`${props.customClass}`]: !!props.customClass
	});

	const totalItemClassFromProps = classNames({
		"c-common-summary_last-item": true,
		"small-font": !!props.children
	});

	const itemLabelClassFromProps = classNames({
		"c-common-summary_item_label": true,
		"extended-flex-basis": props.extraWidth
	});

	return (
		<div className={containerClassFromProps} style={props.style}>
			{props.items.map((item, index) => renderSummaryItem(item, index, itemLabelClassFromProps))}
			<div className="c-common-summary_item_horizontal-line"/>
			<div className={totalItemClassFromProps}>
				<div className={itemLabelClassFromProps}>{props.totalItem.label}</div>
				<div className="c-common-summary_item_label">{props.totalItem.value}</div>
			</div>
			{!props.children && <div className="c-common-summary_item_horizontal-line has-margin-bottom"/>}
			<div className="c-common-summary_item_horizontal-line"/>
			{props.renderTooltipParentElement && props.renderTooltipParentElement()}
			{props.lastItem &&
			<div className="c-common-summary_item italic" style={{marginTop: "-30px"}}>
				<div className={itemLabelClassFromProps}>{props.lastItem.label}</div>
				<div className="c-common-summary_item_label">{props.lastItem.value}</div>
			</div>}
			{props.children}
		</div>
	);
};

const renderSummaryItem = (item: DetailsSummaryItem, index: number, itemLabelClass: string) => {
	const containerClassFromProps = classNames({
		"c-common-summary_item": true,
		"italic": item.italic
	});
	return (
		<div key={index} className={containerClassFromProps}>
			<div className={itemLabelClass}>{item.label}</div>
			<div className="c-common-summary_item_label">{item.value}</div>
		</div>
	);
};
